import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

import type { GuardianProfile } from './get-guardian';

/** Body for PATCH /api/v1/guardians/me/notification-preferences. */
export type NotificationPreferencesUpdate = auth.UpdateNotificationPreferencesRequest;

/**
 * Saves the caller's notification opt-ins (onboarding step 4) via PATCH
 * `/api/v1/guardians/me/notification-preferences`. Returns the refreshed guardian
 * profile (with the updated `notificationPreferences` block).
 */
export async function updateNotificationPreferences(
  data: NotificationPreferencesUpdate,
): Promise<GuardianProfile> {
  return await AuthServices.updateNotificationPreferences(data);
}
